import { useRef, useState, useEffect } from 'react';
import { Status } from '@grandvisionhq/api-client';
import { onConsentChange } from '@grandvisionhq/cookie-consent';
import { v4 } from 'uuid';
import { Cookies } from '@grandvisionhq/utils';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

function generateIdentifierName(key) {
    return `__prid_${key}`;
}
function generateRandomId(key) {
    return {
        name: generateIdentifierName(key),
        value: v4()
    };
}
/**
 * storage is where the random id persists e.g. cookies
 */ function getPersistentRandomId(key, storage) {
    const identifier = generateIdentifierName(key);
    // check document.cookie
    if (!storage && typeof document !== 'undefined') {
        storage = document.cookie;
    }
    if (!storage) {
        return null;
    }
    // raw cookie
    if (typeof storage === 'string') {
        return Cookies.parseCookieString(storage)[identifier] || null;
    }
    // cookie object
    return (storage === null || storage === void 0 ? void 0 : storage[identifier]) || null;
}
// uuid v4 regex
const PersistentRandomIdPattern = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

function usePersistentRandomId(key) {
    const mounted = useRef(true);
    const [id, setId] = useState(()=>{
        return getPersistentRandomId(key);
    });
    useEffect(()=>{
        if (id) {
            return;
        }
        function handler() {
            return _handler.apply(this, arguments);
        }
        function _handler() {
            _handler = _asyncToGenerator(function*() {
                // prevent state update on unmounted component
                if (!mounted.current) {
                    return;
                }
                try {
                    yield Status.getVersion(window.location.origin);
                } catch (e) {} finally{
                    setId(getPersistentRandomId(key));
                }
            });
            return _handler.apply(this, arguments);
        }
        onConsentChange(handler);
    }, [
        id,
        key
    ]);
    useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return id;
}

export { PersistentRandomIdPattern, generateRandomId, getPersistentRandomId, usePersistentRandomId };
//# sourceMappingURL=index.js.map
